/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Rocket.net API
 * Rocket.net - All APIs
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery, useSuspenseQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';

import { customFetch } from '../../custom-fetch';
import { addMetaToQuery } from '../../mutators/add-meta';
import { addMetaToMutation } from '../../mutators/add-meta';
import type {
  AddPasswordProtectionUserRequest,
  AddPasswordProtectionUserResponse,
  Error,
  GetPasswordProtectionResponse,
  ListPasswordProtectionUsersResponse,
  ListSitePasswordProtectionUsersParams,
  SiteID,
  SuccessResponse,
} from '../rocketNetAPI.schemas';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

/**
 * Returns whether visitor password protection is currently enabled for this site.
 * @summary Get site password protection status
 */
export const findSitePasswordProtection = (id: SiteID, signal?: AbortSignal) => {
  return customFetch<GetPasswordProtectionResponse>({
    url: `/v1/sites/${id}/password_protection`,
    method: 'GET',
    signal,
  });
};

export const getFindSitePasswordProtectionQueryKey = (id?: SiteID) => {
  return [`/v1/sites/${id}/password_protection`] as const;
};

export const getFindSitePasswordProtectionQueryOptions = <
  TData = Awaited<ReturnType<typeof findSitePasswordProtection>>,
  TError = Error,
>(
  id: SiteID,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof findSitePasswordProtection>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getFindSitePasswordProtectionQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof findSitePasswordProtection>>> = ({
    signal,
  }) => findSitePasswordProtection(id, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id },
    {
      url: `/v1/sites/${id}/password_protection`,
      operationId: 'app.controllers.password_protection_controller.find_site_password_protection',
      operationName: 'findSitePasswordProtection',
    }
  );

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof findSitePasswordProtection>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FindSitePasswordProtectionQueryResult = NonNullable<
  Awaited<ReturnType<typeof findSitePasswordProtection>>
>;
export type FindSitePasswordProtectionQueryError = Error;

export function useFindSitePasswordProtection<
  TData = Awaited<ReturnType<typeof findSitePasswordProtection>>,
  TError = Error,
>(
  id: SiteID,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof findSitePasswordProtection>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findSitePasswordProtection>>,
          TError,
          Awaited<ReturnType<typeof findSitePasswordProtection>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFindSitePasswordProtection<
  TData = Awaited<ReturnType<typeof findSitePasswordProtection>>,
  TError = Error,
>(
  id: SiteID,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof findSitePasswordProtection>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findSitePasswordProtection>>,
          TError,
          Awaited<ReturnType<typeof findSitePasswordProtection>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFindSitePasswordProtection<
  TData = Awaited<ReturnType<typeof findSitePasswordProtection>>,
  TError = Error,
>(
  id: SiteID,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof findSitePasswordProtection>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get site password protection status
 */

export function useFindSitePasswordProtection<
  TData = Awaited<ReturnType<typeof findSitePasswordProtection>>,
  TError = Error,
>(
  id: SiteID,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof findSitePasswordProtection>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getFindSitePasswordProtectionQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getFindSitePasswordProtectionSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof findSitePasswordProtection>>,
  TError = Error,
>(
  id: SiteID,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof findSitePasswordProtection>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getFindSitePasswordProtectionQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof findSitePasswordProtection>>> = ({
    signal,
  }) => findSitePasswordProtection(id, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id },
    {
      url: `/v1/sites/${id}/password_protection`,
      operationId: 'app.controllers.password_protection_controller.find_site_password_protection',
      operationName: 'findSitePasswordProtection',
    }
  );

  return customOptions as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof findSitePasswordProtection>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FindSitePasswordProtectionSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof findSitePasswordProtection>>
>;
export type FindSitePasswordProtectionSuspenseQueryError = Error;

export function useFindSitePasswordProtectionSuspense<
  TData = Awaited<ReturnType<typeof findSitePasswordProtection>>,
  TError = Error,
>(
  id: SiteID,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof findSitePasswordProtection>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFindSitePasswordProtectionSuspense<
  TData = Awaited<ReturnType<typeof findSitePasswordProtection>>,
  TError = Error,
>(
  id: SiteID,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof findSitePasswordProtection>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFindSitePasswordProtectionSuspense<
  TData = Awaited<ReturnType<typeof findSitePasswordProtection>>,
  TError = Error,
>(
  id: SiteID,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof findSitePasswordProtection>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get site password protection status
 */

export function useFindSitePasswordProtectionSuspense<
  TData = Awaited<ReturnType<typeof findSitePasswordProtection>>,
  TError = Error,
>(
  id: SiteID,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof findSitePasswordProtection>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getFindSitePasswordProtectionSuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Requires visitors to enter a username and password before they can view the site. Add authorized users with the password protection users endpoints.
 * @summary Enable site password protection
 */
export const enableSitePasswordProtection = (id: SiteID, signal?: AbortSignal) => {
  return customFetch<SuccessResponse>({
    url: `/v1/sites/${id}/password_protection`,
    method: 'POST',
    signal,
  });
};

export const getEnableSitePasswordProtectionMutationOptions = <
  TError = Error,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof enableSitePasswordProtection>>,
    TError,
    { id: SiteID },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof enableSitePasswordProtection>>,
  TError,
  { id: SiteID },
  TContext
> => {
  const mutationKey = ['enableSitePasswordProtection'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof enableSitePasswordProtection>>,
    { id: SiteID }
  > = props => {
    const { id } = props ?? {};

    return enableSitePasswordProtection(id);
  };

  const customOptions = addMetaToMutation(
    { ...mutationOptions, mutationFn },
    { url: `/v1/sites/{id}/password_protection` },
    {
      operationId: 'app.controllers.password_protection_controller.enable_site_password_protection',
      operationName: 'enableSitePasswordProtection',
    }
  );

  return customOptions;
};

export type EnableSitePasswordProtectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof enableSitePasswordProtection>>
>;

export type EnableSitePasswordProtectionMutationError = Error;

/**
 * @summary Enable site password protection
 */
export const useEnableSitePasswordProtection = <TError = Error, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof enableSitePasswordProtection>>,
      TError,
      { id: SiteID },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof enableSitePasswordProtection>>,
  TError,
  { id: SiteID },
  TContext
> => {
  const mutationOptions = getEnableSitePasswordProtectionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Makes the site publicly accessible again without requiring visitor credentials.
 * @summary Disable site password protection
 */
export const disableSitePasswordProtection = (id: SiteID) => {
  return customFetch<SuccessResponse>({
    url: `/v1/sites/${id}/password_protection`,
    method: 'DELETE',
  });
};

export const getDisableSitePasswordProtectionMutationOptions = <
  TError = Error,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof disableSitePasswordProtection>>,
    TError,
    { id: SiteID },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof disableSitePasswordProtection>>,
  TError,
  { id: SiteID },
  TContext
> => {
  const mutationKey = ['disableSitePasswordProtection'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof disableSitePasswordProtection>>,
    { id: SiteID }
  > = props => {
    const { id } = props ?? {};

    return disableSitePasswordProtection(id);
  };

  const customOptions = addMetaToMutation(
    { ...mutationOptions, mutationFn },
    { url: `/v1/sites/{id}/password_protection` },
    {
      operationId:
        'app.controllers.password_protection_controller.disable_site_password_protection',
      operationName: 'disableSitePasswordProtection',
    }
  );

  return customOptions;
};

export type DisableSitePasswordProtectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof disableSitePasswordProtection>>
>;

export type DisableSitePasswordProtectionMutationError = Error;

/**
 * @summary Disable site password protection
 */
export const useDisableSitePasswordProtection = <TError = Error, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof disableSitePasswordProtection>>,
      TError,
      { id: SiteID },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof disableSitePasswordProtection>>,
  TError,
  { id: SiteID },
  TContext
> => {
  const mutationOptions = getDisableSitePasswordProtectionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Returns usernames allowed to access the password-protected site. Supports pagination, search by username, and sorting.
 * @summary List authorized visitor user accounts
 */
export const listSitePasswordProtectionUsers = (
  id: SiteID,
  params?: ListSitePasswordProtectionUsersParams,
  signal?: AbortSignal
) => {
  return customFetch<ListPasswordProtectionUsersResponse>({
    url: `/v1/sites/${id}/password_protection/users`,
    method: 'GET',
    params,
    signal,
  });
};

export const getListSitePasswordProtectionUsersQueryKey = (
  id?: SiteID,
  params?: ListSitePasswordProtectionUsersParams
) => {
  return [`/v1/sites/${id}/password_protection/users`, ...(params ? [params] : [])] as const;
};

export const getListSitePasswordProtectionUsersQueryOptions = <
  TData = Awaited<ReturnType<typeof listSitePasswordProtectionUsers>>,
  TError = Error,
>(
  id: SiteID,
  params?: ListSitePasswordProtectionUsersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSitePasswordProtectionUsers>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListSitePasswordProtectionUsersQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listSitePasswordProtectionUsers>>> = ({
    signal,
  }) => listSitePasswordProtectionUsers(id, params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, params },
    {
      url: `/v1/sites/${id}/password_protection/users`,
      operationId:
        'app.controllers.password_protection_controller.list_site_password_protection_users',
      operationName: 'listSitePasswordProtectionUsers',
    }
  );

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof listSitePasswordProtectionUsers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListSitePasswordProtectionUsersQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSitePasswordProtectionUsers>>
>;
export type ListSitePasswordProtectionUsersQueryError = Error;

export function useListSitePasswordProtectionUsers<
  TData = Awaited<ReturnType<typeof listSitePasswordProtectionUsers>>,
  TError = Error,
>(
  id: SiteID,
  params: undefined | ListSitePasswordProtectionUsersParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSitePasswordProtectionUsers>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSitePasswordProtectionUsers>>,
          TError,
          Awaited<ReturnType<typeof listSitePasswordProtectionUsers>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSitePasswordProtectionUsers<
  TData = Awaited<ReturnType<typeof listSitePasswordProtectionUsers>>,
  TError = Error,
>(
  id: SiteID,
  params?: ListSitePasswordProtectionUsersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSitePasswordProtectionUsers>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSitePasswordProtectionUsers>>,
          TError,
          Awaited<ReturnType<typeof listSitePasswordProtectionUsers>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSitePasswordProtectionUsers<
  TData = Awaited<ReturnType<typeof listSitePasswordProtectionUsers>>,
  TError = Error,
>(
  id: SiteID,
  params?: ListSitePasswordProtectionUsersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSitePasswordProtectionUsers>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List authorized visitor user accounts
 */

export function useListSitePasswordProtectionUsers<
  TData = Awaited<ReturnType<typeof listSitePasswordProtectionUsers>>,
  TError = Error,
>(
  id: SiteID,
  params?: ListSitePasswordProtectionUsersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSitePasswordProtectionUsers>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListSitePasswordProtectionUsersQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getListSitePasswordProtectionUsersSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof listSitePasswordProtectionUsers>>,
  TError = Error,
>(
  id: SiteID,
  params?: ListSitePasswordProtectionUsersParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof listSitePasswordProtectionUsers>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListSitePasswordProtectionUsersQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listSitePasswordProtectionUsers>>> = ({
    signal,
  }) => listSitePasswordProtectionUsers(id, params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, params },
    {
      url: `/v1/sites/${id}/password_protection/users`,
      operationId:
        'app.controllers.password_protection_controller.list_site_password_protection_users',
      operationName: 'listSitePasswordProtectionUsers',
    }
  );

  return customOptions as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof listSitePasswordProtectionUsers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListSitePasswordProtectionUsersSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSitePasswordProtectionUsers>>
>;
export type ListSitePasswordProtectionUsersSuspenseQueryError = Error;

export function useListSitePasswordProtectionUsersSuspense<
  TData = Awaited<ReturnType<typeof listSitePasswordProtectionUsers>>,
  TError = Error,
>(
  id: SiteID,
  params: undefined | ListSitePasswordProtectionUsersParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof listSitePasswordProtectionUsers>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSitePasswordProtectionUsersSuspense<
  TData = Awaited<ReturnType<typeof listSitePasswordProtectionUsers>>,
  TError = Error,
>(
  id: SiteID,
  params?: ListSitePasswordProtectionUsersParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof listSitePasswordProtectionUsers>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSitePasswordProtectionUsersSuspense<
  TData = Awaited<ReturnType<typeof listSitePasswordProtectionUsers>>,
  TError = Error,
>(
  id: SiteID,
  params?: ListSitePasswordProtectionUsersParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof listSitePasswordProtectionUsers>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List authorized visitor user accounts
 */

export function useListSitePasswordProtectionUsersSuspense<
  TData = Awaited<ReturnType<typeof listSitePasswordProtectionUsers>>,
  TError = Error,
>(
  id: SiteID,
  params?: ListSitePasswordProtectionUsersParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof listSitePasswordProtectionUsers>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListSitePasswordProtectionUsersSuspenseQueryOptions(id, params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Creates a username and password that visitors can use to access the site while password protection is enabled.
 * @summary Add an authorized visitor user account
 */
export const createSitePasswordProtectionUser = (
  id: SiteID,
  addPasswordProtectionUserRequest: AddPasswordProtectionUserRequest,
  signal?: AbortSignal
) => {
  return customFetch<AddPasswordProtectionUserResponse>({
    url: `/v1/sites/${id}/password_protection/users`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: addPasswordProtectionUserRequest,
    signal,
  });
};

export const getCreateSitePasswordProtectionUserMutationOptions = <
  TError = Error,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSitePasswordProtectionUser>>,
    TError,
    { id: SiteID; data: AddPasswordProtectionUserRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSitePasswordProtectionUser>>,
  TError,
  { id: SiteID; data: AddPasswordProtectionUserRequest },
  TContext
> => {
  const mutationKey = ['createSitePasswordProtectionUser'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSitePasswordProtectionUser>>,
    { id: SiteID; data: AddPasswordProtectionUserRequest }
  > = props => {
    const { id, data } = props ?? {};

    return createSitePasswordProtectionUser(id, data);
  };

  const customOptions = addMetaToMutation(
    { ...mutationOptions, mutationFn },
    { url: `/v1/sites/{id}/password_protection/users` },
    {
      operationId:
        'app.controllers.password_protection_controller.create_site_password_protection_user',
      operationName: 'createSitePasswordProtectionUser',
    }
  );

  return customOptions;
};

export type CreateSitePasswordProtectionUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof createSitePasswordProtectionUser>>
>;
export type CreateSitePasswordProtectionUserMutationBody = AddPasswordProtectionUserRequest;
export type CreateSitePasswordProtectionUserMutationError = Error;

/**
 * @summary Add an authorized visitor user account
 */
export const useCreateSitePasswordProtectionUser = <TError = Error, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createSitePasswordProtectionUser>>,
      TError,
      { id: SiteID; data: AddPasswordProtectionUserRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createSitePasswordProtectionUser>>,
  TError,
  { id: SiteID; data: AddPasswordProtectionUserRequest },
  TContext
> => {
  const mutationOptions = getCreateSitePasswordProtectionUserMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Revokes a visitor's access to the password-protected site.
 * @summary Remove an authorized visitor user account
 */
export const deleteSitePasswordProtectionUser = (id: SiteID, userId: number) => {
  return customFetch<SuccessResponse>({
    url: `/v1/sites/${id}/password_protection/users/${userId}`,
    method: 'DELETE',
  });
};

export const getDeleteSitePasswordProtectionUserMutationOptions = <
  TError = Error,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSitePasswordProtectionUser>>,
    TError,
    { id: SiteID; userId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSitePasswordProtectionUser>>,
  TError,
  { id: SiteID; userId: number },
  TContext
> => {
  const mutationKey = ['deleteSitePasswordProtectionUser'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSitePasswordProtectionUser>>,
    { id: SiteID; userId: number }
  > = props => {
    const { id, userId } = props ?? {};

    return deleteSitePasswordProtectionUser(id, userId);
  };

  const customOptions = addMetaToMutation(
    { ...mutationOptions, mutationFn },
    { url: `/v1/sites/{id}/password_protection/users/{userId}` },
    {
      operationId:
        'app.controllers.password_protection_controller.delete_site_password_protection_user',
      operationName: 'deleteSitePasswordProtectionUser',
    }
  );

  return customOptions;
};

export type DeleteSitePasswordProtectionUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSitePasswordProtectionUser>>
>;

export type DeleteSitePasswordProtectionUserMutationError = Error;

/**
 * @summary Remove an authorized visitor user account
 */
export const useDeleteSitePasswordProtectionUser = <TError = Error, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteSitePasswordProtectionUser>>,
      TError,
      { id: SiteID; userId: number },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteSitePasswordProtectionUser>>,
  TError,
  { id: SiteID; userId: number },
  TContext
> => {
  const mutationOptions = getDeleteSitePasswordProtectionUserMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
